import { render } from "./PaymentCheckout.vue?vue&type=template&id=28ad0dcc&scoped=true"
import script from "./PaymentCheckout.vue?vue&type=script&lang=js"
export * from "./PaymentCheckout.vue?vue&type=script&lang=js"

import "./PaymentCheckout.vue?vue&type=style&index=0&id=28ad0dcc&scoped=true&lang=css"

import exportComponent from "/Users/fikri/Work/PRiADI/code/priadi-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28ad0dcc"]])

export default __exports__